module.exports = __webpack_public_path__ + "static/resume.f260142f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/resume.pdf
// module id = 284
// module chunks = 156897593687669